import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import AS from './AS';
import KS from './KS';

export const defaultNS = 'ns1';

export const resources = {
    AS: {
        translation: AS
    },
    KS: {
        translation: KS
    }
} as const;

i18n
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: ['AS', 'KS'],
        lng: 'AS',
        fallbackLng: 'AS'
    });

export default i18n;
